import { RelationContextType } from '@components/EntityDrawers/drawers/Relationship/constants/types';

export const MainLabels = {
  [RelationContextType.ServiceCapability]: 'Control requirement',
  [RelationContextType.CapabilityFunction]: 'Control objective',
  [RelationContextType.FunctionTechnology]: 'Control reference',
} as const;

export const UnderLabels = {
  [RelationContextType.ServiceCapability]: 'Underpinning control requirements',
  [RelationContextType.CapabilityFunction]: 'Underpinning control references',
  [RelationContextType.FunctionTechnology]: '-',
} as const;

export const UnderPlaceholders = {
  [RelationContextType.ServiceCapability]: 'Control requirement',
  [RelationContextType.CapabilityFunction]: 'Control reference',
  [RelationContextType.FunctionTechnology]: '-',
} as const;
